import styles from './styles.module.css'

/** Cabeçalho de página: título + descrição à esquerda, ações à direita. */
export const PageHeader: React.FC<{
  title: string
  description?: string
  actions?: React.ReactNode
}> = ({ title, description, actions }) => (
  <div className={styles.header}>
    <div className={styles.titleGroup}>
      <h1 className={styles.title}>{title}</h1>
      {!!description && <p className={styles.description}>{description}</p>}
    </div>
    {!!actions && <div className={styles.headerActions}>{actions}</div>}
  </div>
)
